const userModel = {
    "firstname": "firstname",
    "lastname": "lastname",
    "email": "email"
}
export default  userModel;